import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getContentCategoriesList = async () => {
  return await axiosInstance.get("homepage/content-categories/getlist", {
    headers,
  });
};

export const getContentCategoryById = async (id) => {
  const response = await axiosInstance.get(
    `homepage/content-categories/get/${id}`,
    { headers }
  );
  return response.data.result;
};

export const addContentCategory = async (payload) => {
  return await axiosInstance.post(
    "homepage/content-categories/add",
    payload,
    { headers }
  );
};

export const updateContentCategory = async (payload) => {
  return await axiosInstance.put(
    "homepage/content-categories/update",
    payload,
    { headers }
  );
};

export const deleteContentCategory = async (id) => {
  return await axiosInstance.delete(
    `homepage/content-categories/delete/${id}`,
    { headers }
  );
};
